export default () => ({
  root: {
    borderRadius: 4,
  },
  input: {
    padding: 16,
  },
  multiline: {
    padding: 0,
  },
  underline: {
    "&:before": {
      border: "unset",
      content: "unset",
    },
  },
  disabled: {
    border: "unset",
  },
});
